import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';

/* ── Suppress the CRA "Uncaught runtime errors" overlay for ChunkLoadErrors ──
   CRA's overlay listens to the global `error` and `unhandledrejection` events.
   We intercept them first: if it's a chunk/network error we stop propagation
   so the overlay never appears. The ErrorBoundary above handles the UI. */
window.addEventListener('error', (event) => {
  const msg = event?.message || '';
  const isChunk =
    event?.error?.name === 'ChunkLoadError' ||
    /Loading chunk .+ failed/i.test(msg) ||
    /loading CSS chunk/i.test(msg);
  if (isChunk) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
}, true /* capture phase — runs before CRA's listener */);

window.addEventListener('unhandledrejection', (event) => {
  const msg = event?.reason?.message || '';
  const isChunk =
    event?.reason?.name === 'ChunkLoadError' ||
    /Loading chunk .+ failed/i.test(msg) ||
    /loading CSS chunk/i.test(msg);
  if (isChunk) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
